// actionCreators.js

import axios from 'axios';
import Cookies from 'js-cookie';
import { rootAPI } from '../../config/api/index';

export const FETCH_FB_MESSAGES_REQUEST = 'FETCH_FB_MESSAGES_REQUEST';
export const FETCH_FB_MESSAGES_SUCCESS = 'FETCH_FB_MESSAGES_SUCCESS';
export const FETCH_FB_MESSAGES_FAILURE = 'FETCH_FB_MESSAGES_FAILURE';
export const RESET_FB_MESSAGES = 'RESET_FB_MESSAGES';

export const FETCH_FACEBOOK_DATA_REQUEST = 'FETCH_FACEBOOK_DATA_REQUEST';
export const FETCH_FACEBOOK_DATA_SUCCESS = 'FETCH_FACEBOOK_DATA_SUCCESS';
export const FETCH_FACEBOOK_DATA_FAILURE = 'FETCH_FACEBOOK_DATA_FAILURE';

export const fetchFbMessagesRequest = () => ({
  type: FETCH_FB_MESSAGES_REQUEST,
});

export const fetchFbMessagesSuccess = (data, isLoadMore) => ({
  type: FETCH_FB_MESSAGES_SUCCESS,
  payload: { ...data, isLoadMore },
});

export const fetchFbMessagesFailure = (error) => ({
  type: FETCH_FB_MESSAGES_FAILURE,
  payload: error,
});

export const resetFbMessages = () => ({
  type: RESET_FB_MESSAGES,
});

export const fetchPostRequest = () => ({
  type: FETCH_FACEBOOK_DATA_REQUEST,
});

export const fetchPostSuccess = (data) => ({
  type: FETCH_FACEBOOK_DATA_SUCCESS,
  payload: data,
});

export const fetchPostFailure = (error) => ({
  type: FETCH_FACEBOOK_DATA_FAILURE,
  payload: error,
});

export const fetchFacebookMessages = (appId, limit = 10, after = null) => {
  const token = Cookies.get('token');
  return async (dispatch) => {
    if (!after) {
      dispatch(fetchFbMessagesRequest());
    }

    try {
      let url = `${rootAPI}/api/facebook/messages/${appId}?limit=${limit}`;
      if (after) {
        url += `&after=${after}`;
      }

      const response = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      // response.data contains: { data: [], paging: { cursors: { after: '...' } }, pageId: '...' }
      dispatch(fetchFbMessagesSuccess(response.data, !!after));
    } catch (error) {
      const errorMsg = error.response?.data?.error || error.message;
      dispatch(fetchFbMessagesFailure(errorMsg));
    }
  };
};

export const fetchFacebookPost = (appData) => {
  return async (dispatch) => {
    dispatch(fetchPostRequest());
    try {
      const response = await axios.get(`${rootAPI}/api/timeline-posts/${appData?.app_id}`);
      fetchPostSuccess(response.data.posts);
    } catch (error) {
      dispatch(fetchPostFailure(error.message));
    }
  };
};
